import { DataList } from '@nimbus-ds/patterns';
import { Repeater } from 'commons/components';
import { TransferListRowSkeleton } from './TransferListRow';

const rowSkeleton = () => <TransferListRowSkeleton />;

export function TransferMobileSkeleton() {
  return (
    <DataList>
      <div className="stratus--margins-expand">
        <Repeater times={5} item={rowSkeleton} />
      </div>
    </DataList>
  );
}
